import { modalOpenPdfPageflip } from "..";
import { purify } from "../../_src/components/purify";

export function searchAndloadMoreMagazines() {
    var btnLoadMore = document.querySelector("[data-action=load-more-revistas]")

    function loadMore(loadMore) {
        var form = document.querySelector('#filter-revistas');
        var data = new FormData(form);

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        if (!loadMore) {
            document.querySelector("#result-revistas").innerHTML = ""
            document.querySelector(".loader-magazines").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-revistas fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        fetch(`/acervo-digital/revista-campo/ajax/magazines/p${pagina}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-revistas").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-revistas").innerHTML = purify(response);

                searchAndloadMoreMagazines();
            }

        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {

            if (!loadMore) {
                document.querySelector(".loader-magazines").classList.add("hidden")
            }

            modalOpenPdfPageflip();

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-revistas fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })

        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMore(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-revistas").addEventListener("change", function(event) { event.preventDefault(), setTimeout(() => { loadMore(false) }, 100),btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);
}


if (document.querySelector("#filter-revistas")) {
    searchAndloadMoreMagazines();
}
